import { Grid } from '@mui/system';
import { MeasurementDate } from 'api';
import { useStore } from 'common/store';
import { CustomContainer } from 'components';
import Information from 'dashboard409a/pages/Information/Information';
import { useCompanyMeasurementDateFilter } from 'services/hooks';

interface RequestDocumentsViewProps {
  showDocumentGenerationJobsTab?: boolean;
}

const RequestDocumentsView = ({ showDocumentGenerationJobsTab = true }: RequestDocumentsViewProps) => {
  const [{ companyInfo }] = useStore();
  const { selectedMeasurementDate, MDDialogue, measurementDates } = useCompanyMeasurementDateFilter();

  return (
    <CustomContainer>
      <Grid size={{ xs: 12 }}>
        <Information
          is409a={false}
          currentCompany={companyInfo}
          currentMeasurementDateId={selectedMeasurementDate?.id}
          currentCompanyMeasurementDateId={selectedMeasurementDate?.cmd_id as number}
          measurementDates={measurementDates}
          selectedMeasurementDate={selectedMeasurementDate as MeasurementDate}
          showDocumentGenerationJobsTab={showDocumentGenerationJobsTab}
        />
      </Grid>
      <MDDialogue />
    </CustomContainer>
  );
};

export default RequestDocumentsView;
